const getFileExtFromUrl = (url: string): string | undefined => {
    // this matches ext only such as `.png`
    // const matches = url.match(/\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gim);
    const matches = url.match(/([\w-]+)(\.[\w-]+)+(?!.*\/)/g);
    const ext = matches?.length ? matches[0] : undefined;
    return ext;
};

export default getFileExtFromUrl;
